import React, { FunctionComponent } from 'react';
import { TradingPlatformsButtons } from '@monorepo/react-components';
import { getPlatformButtonStyles } from '../styles';
import { PlatformButtonsSectionProps } from '../types';

export const PlatformButtonsSection: FunctionComponent<
  PlatformButtonsSectionProps
> = ({ tradingSystem, direction, isPrimaryColor = false }) => {
  return (
    <TradingPlatformsButtons
      tradingSystem={tradingSystem}
      gap={2}
      showDownloadIcon={true}
      showPlatformIcon={true}
      buttonSx={(theme) => getPlatformButtonStyles(theme, isPrimaryColor)}
      containerSx={{
        mt: 2,
        ...(direction === 'column' && {
          gridTemplateColumns: '1fr',
        }),
      }}
    />
  );
};
